import { render, staticRenderFns } from "./Dialog_StudentAddEducationalExperiences.vue?vue&type=template&id=77f72d51&scoped=true&"
import script from "./Dialog_StudentAddEducationalExperiences.vue?vue&type=script&lang=js&"
export * from "./Dialog_StudentAddEducationalExperiences.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_StudentAddEducationalExperiences.vue?vue&type=style&index=0&id=77f72d51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f72d51",
  null
  
)

export default component.exports